import React, { createContext, useContext } from 'react'
import useGenealogyTrees from './useGenealogyTrees'

const GenealogyTrees = createContext()

export const useGenealogyTreesContext = () => {
  const context = useContext(GenealogyTrees)
  if (!context) throw new Error('You need to use the GenealogyTreesProvider to use the useGenealogyTrees')
  return context
}

export default function GenealogyTreesProvider({ children, testData }) {
  const hookData = useGenealogyTrees()
  const value = testData ?? hookData
  return <GenealogyTrees.Provider value={value}>{children}</GenealogyTrees.Provider>
}
